// extracted by mini-css-extract-plugin
export default {"wrapper":"lA-z","viewport":"mA-z","container":"nA-z","slide":"oA-z"};